import type { ReactElement } from "react";
import type { CatalogField } from "../types.js";
import { maskValue, displayValue } from "../lib/display.js";

interface Props {
  fields: CatalogField[];
  data: Record<string, unknown> | null;
}

/** Generic detail renderer. PII fields are masked; revealing is a separate audited action. */
export function DetailView({ fields, data }: Props): ReactElement {
  if (!data) return <p>No data.</p>;
  return (
    <dl className="detail">
      {fields.map((f) => {
        const raw = data[f.id];
        const shown = f.pii ? maskValue(f, raw) : displayValue(f, raw);
        return (
          <div key={f.id} className="detail-row">
            <dt>{f.label ?? f.id}</dt>
            <dd>
              {shown}
              {f.pii ? (
                <span className="pii-badge" aria-label="contains personal data">
                  {" "}
                  PII
                </span>
              ) : null}
              {f.description ? <p className="field-hint">{f.description}</p> : null}
            </dd>
          </div>
        );
      })}
    </dl>
  );
}
